import React from "react";
import { createRoot } from "react-dom/client";
import NewsSearch from "./NewsSearch";

export function renderNewsSearch(rootId, roles) {
	const root = createRoot(document.getElementById(rootId));
	root.render(<NewsSearch roles={roles} />);
}

window.renderNewsSearch = renderNewsSearch;
